import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import middleware from 'i18next-http-middleware';

import translationEn from "./locales/en/translation.json" with { type: 'json' };
import translationTC from "./locales/zh/translation.json" with { type: 'json' };
import translationSC from "./locales/zh-cn/translation.json" with { type: 'json' };

const isServer = typeof window === 'undefined'

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(isServer ? middleware.LanguageDetector : LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options  
  .init({
    fallbackLng: "zh",
    supportedLngs: ['en', 'zh', 'sc'], // your supported languages

    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    detection: {
      order: isServer ? ['path', 'session', 'querystring', 'cookie', 'header'] : ['localStorage', 'cookie'],
      caches: ["localStorage"],
    },
    debug: true,

    resources: {
      en: {
        translation: translationEn
      },
      zh: {
        translation: translationTC
      },
      sc: {
        translation: translationSC
      }
    }
  });



export default i18n;
